import { Box, Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { appBaseUrl } from "@utils/BASE-URL";
import { CONTACT_NUMBER, WEB_ENGAGE } from "@utils/constants";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import style from "../../../styles/pujaDetails.module.css";
import { NoSsr } from "@material-ui/core";
import { WhatsApp } from "@mui/icons-material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import Temple from "@public/assets/icons/templehindu.svg";
import { prettyDate } from "@utils/metrics/timeFunction";
import { setEventData } from "@utils/reduxToolkit/features/userSlice";
import Image from "next/legacy/image";
import Link from "next/link";
import { useRouter } from "next/router";
import Countdown from "react-countdown";
import { useDispatch, useSelector } from "react-redux";
import PujaRegisterButton from "../PujaRegisterButton";
import UserListPujaAB from "./UserListPuja";
import CountdownRenderer from "./countdownRenderer";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
// import Stories from "image-stories";

import SliderWrapper from "src/globalModule/components/reactSlick/_SlickSliderStyle";
import ImagePreviewModal from "./ImagePreviewModal";
import { trackEvent } from "@utils/analytics/event-analytics";
const HeaderPujaDetailsAB = ({
  data,
  isAdmin,
  handleToRegister,
  handleToReviews
}) => {
  const {
    t
  } = useTranslation();
  const router = useRouter();
  const bigScreen = useMediaQuery("(min-width:768px)");
  // const dispatch = useDispatch();
  // const eventState = useSelector((state) => state.userDetails);
  // const eventData = eventState ? eventState.eventData : null;

  // const [currentViewNo, setCurrentViewNo] = useState(0);
  const [openImagePreview, setOpenImagePreview] = useState(false);
  const handlePreviewModal = value => {
    setOpenImagePreview(value);
  };

  // useEffect(() => {
  //   // generateRandomNumber();

  //   const interval = setInterval(() => {
  //     generateRandomNumber(); // Generate a new random number every 5 minutes
  //   }, 3 * 60 * 1000); // 3 minutes in milliseconds

  //   return () => clearInterval(interval); // Cleanup function to clear the interval
  // }, []);

  // useEffect(() => {
  //   if (eventData.eventID === data.eventID && eventData.viewNo > 0) {
  //     setCurrentViewNo(eventData.viewNo); // Generate a random number when the component mounts
  //   } else {
  //     generateRandomNumber();
  //   }
  // }, [eventData]);

  // const generateRandomNumber = () => {
  //   let randomNum = Math.floor(Math.random() * 61) + 40; // Generate a random number between 40 and 100

  //   if (currentViewNo > 0) {
  //     randomNum = currentViewNo;
  //   }

  //   const operation = Math.random() < 0.5 ? -1 : 1; // Randomly decide whether to increment or decrement
  //   const increment = Math.floor(Math.random() * 9) + 1; // Generate a random increment value between 1 and 9
  //   randomNum += operation * increment; // Apply the increment or decrement

  //   // Ensure the generated number stays within the range [40, 100]
  //   randomNum = Math.max(40, Math.min(100, randomNum));

  //   setCurrentViewNo(randomNum);
  //   dispatch(
  //     setEventData({
  //       eventID: data.eventID,
  //       viewNo: randomNum,
  //       update: true,
  //     })
  //   );
  // };

  const eventUrl = `${appBaseUrl}/${router.locale}/puja/${data.EventDeityTypes[0]?.DeityType.name}/${data.urlExtension}`;
  let shareMessage = `Namaste Utsav Admin🙏\u2029\u2029Help me register in:\u2029*${data.name}*\u2029\u2029${eventUrl}`;
  const whatsappUrl = encodeURI(`https://api.whatsapp.com/send?phone=91${CONTACT_NUMBER.number}&text=${shareMessage}`);
  const rightBx = useRef(null);
  if (!data) {
    return null;
  }

  // const settings = {
  //   dots: true,
  //   autoplay: false,
  //   autoplaySpeed: 10000,
  //   infinite: true,
  //   slidesToShow: 1.06,
  //   slidesToScroll: 1,
  //   initialSlide: 0,
  //   speed: 300,
  //   arrows: false,
  //   adaptiveHeight: true,
  //   appendDots: (dots) => <ul>{dots}</ul>,
  //   customPaging: (i) => (
  //     <div className="ft-slick__dots--custom">
  //       <div className="loading" />
  //     </div>
  //   ),
  // };

  const settingsForBigScreen = {
    dots: true,
    autoplay: true,
    autoplaySpeed: 10000,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    speed: 300,
    arrows: false,
    adaptiveHeight: true,
    appendDots: dots => <ul>{dots}</ul>,
    customPaging: i => <div className="ft-slick__dots--custom">
        <div className="loading" />
      </div>
  };

  // ------------- AB HEADER --------------- //
  return <>
      {!bigScreen ? <>
          <div>
            {data.images && data.images.length > 1 ? <div className={style.imageCarousel}>
                {data.images.map((item, index) => {
            return <div className={style.singleImageCorousel} key={index} onClick={() => handlePreviewModal(true)}>
                      <Image key={index} src={item} alt={data?.name + ` ${t("image")}`}
              // width={"100%"}
              layout="fill" className={style.imageItself} priority={true} // {false} | {true}
              />
                    </div>;
          })}
              </div> : <div className={style.stories}>
                <Image src={data.images[0]} alt={data?.name + ` ${t("image")}`} priority={true} // {false} | {true}
          className={style.imageItself} layout="fill" />
              </div>}
          </div>

          <div className={style.contentBodyAB}>
            <Box display={"flex"} flexDirection={"column"}>
              <Typography variant="h1" className={style.pujaName} onClick={handleToRegister}>
                {data.name}
              </Typography>
              {data.mainBenefit && <Typography className={style.pujaBenefit}>
                  {data.mainBenefit}
                </Typography>}
            </Box>
            <div className={style.pujaDateTemple}>
              <CalendarMonthIcon sx={{
            color: "#ff5757"
          }} />
              {data.start && <span>
                  {prettyDate(new Date(Number(data.start)), router.locale)}
                  {data?.EventFestivalTimelines?.length > 0 && <>
                      {" "}
                      -{" "}
                      {data?.EventFestivalTimelines[0]?.FestivalTimeline?.title}
                    </>}
                </span>}
            </div>
            <NoSsr>
              {/* <div className={countdownStyles.wrapper}> */}
              <Countdown date={Number(data.start)} renderer={props => <CountdownRenderer days={props.days} hours={props.hours} minutes={props.minutes} seconds={props.seconds} completed={props.completed} />}></Countdown>
              {/* </div> */}
            </NoSsr>

            {data.isVerified && <div className={style.ratingContainer}>
                <UserListPujaAB eventData={data} handleToReviews={handleToReviews} />

                {/* <div className={style.ratingHolder} onClick={handleToRegister}>
                  <RemoveRedEyeIcon style={{ height: "20px" }} />
                   <span className={style.ratingValue}>
                    {currentViewNo} {t("viewing")}
                  </span>
                 </div> */}
              </div>}
          </div>
        </> : <>
          <div className={style.pujaTopContainer}>
            <div className={`${style.imageBox}`}>
              {data.images.length > 1 && <NoSsr>
                  <SliderWrapper scale={1}>
                    <Slider {...settingsForBigScreen}>
                      {data.images.map((image, index) => <div key={index} className={style.demoImageCardWrapper} onClick={() => handlePreviewModal(true)}>
                          <Image src={image ?? ""} alt={t("temple-image")}
                  // className={style.blogCardImg}
                  // width={"100%"}
                  // height={"100%"}
                  layout="fill" objectFit="cover" placeholder="blur" blurDataURL={image ?? ""} loading="lazy" />
                        </div>)}
                    </Slider>
                  </SliderWrapper>
                </NoSsr>}

              {data.images.length === 1 && <Image src={data.images[0]} alt={data?.name + ` ${t("dp")}`}
          // width={500}
          // height={500}
          // layout="intrinsic"
          layout="fill" objectFit="cover" priority
          // className={style.mImg}
          />}
            </div>

            <div ref={rightBx} className={style.contentBody}>
              <Typography variant="h1" className={style.pujaName}>{data.name}</Typography>

              <div className={style.pujaDateTemple}>
                <Temple />
                <span> {data.templeName} </span>
              </div>

              <div className={style.pujaDateTemple}>
                <CalendarMonthIcon sx={{
              color: "#ff5757"
            }} />
                {data?.EventFestivalTimelines.length > 0 ? <span>
                    {prettyDate(new Date(Number(data?.EventFestivalTimelines[0]?.FestivalTimeline?.date)), router.locale)}{" "}
                    - {data?.EventFestivalTimelines[0]?.FestivalTimeline?.title}
                  </span> : <span>
                    {prettyDate(new Date(Number(data?.start)), router.locale)}
                  </span>}
              </div>

              {data.isVerified && !data.isClosed && <>
                  <NoSsr>
                    {/* <div className={countdownStyles.wrapper}> */}
                    <Countdown date={Number(data.start)} renderer={props => <CountdownRenderer days={props.days} hours={props.hours} minutes={props.minutes} seconds={props.seconds} completed={props.completed} avgRating={data.avgRating} />}></Countdown>
                    {/* </div> */}
                  </NoSsr>

                  <UserListPujaAB eventData={data} />

                  <div className={style.headerButtonsContainer}>
                    <PujaRegisterButton data={data} clicked_from={WEB_ENGAGE.CLICKED_FROMS.KRIYA_BOX} handleToRegister={handleToRegister} // @arnab check
              visibleBookBtn={true} />

                    <button className={style.supportButton}>
                      <WhatsApp className={style.whatsappIcon} />
                      <Link href={whatsappUrl} target="_blank" rel="noopener noreferrer alternate" hrefLang={router.locale} onClick={() => {
                  trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS + " " + WEB_ENGAGE.BUTTON_NAMES.HELPLINE_NUMBER + " " + WEB_ENGAGE.EVENT_NAMES.BUTTON_CLICKED, {
                    [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS,
                    [WEB_ENGAGE.EVENT_PROPERTIES.BUTTON_NAME]: WEB_ENGAGE.BUTTON_NAMES.HELPLINE_NUMBER,
                    [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: data.name_WE,
                    [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_DEITY_TYPE]: data?.EventDeityTypes[0]?.DeityType?.name,
                    [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: data?.urlExtension
                  });
                }} className={style.pBtnText}>
                        {t("support")}
                      </Link>
                    </button>
                  </div>
                </>}
            </div>
          </div>
        </>}
      {openImagePreview && <ImagePreviewModal openImagePreview={openImagePreview} handlePreviewModal={handlePreviewModal} data={data} handleToRegister={handleToRegister} setOpenImagePreview={setOpenImagePreview} />}
    </>;
};
export default HeaderPujaDetailsAB;